export default {
  campaigns: [],
  loading: false,
  saving: false,
  generatingCopy: false,
  copyVariants: null,
  generationId: null,
  error: null,
};
